/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Pages_Desc5Inputs */

const en_svc_programmatic_seo_pages_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thousands of fast pages from one template, each with unique URLs and internal links.`)
};

const ar_svc_programmatic_seo_pages_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آلاف الصفحات السريعة من قالب واحد، كل منها بروابط فريدة وروابط داخلية.`)
};

const bn_svc_programmatic_seo_pages_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এক টেমপ্লেট থেকে হাজার হাজার দ্রুত পৃষ্ঠা, প্রতিটির অনন্য URL ও অভ্যন্তরীণ লিঙ্ক।`)
};

const de_svc_programmatic_seo_pages_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tausende schnelle Seiten aus einer Vorlage, jede mit einzigartigen URLs und internen Links.`)
};

const es_svc_programmatic_seo_pages_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miles de páginas rápidas desde una plantilla, cada una con URL únicas y enlaces internos.`)
};

const fr_svc_programmatic_seo_pages_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des milliers de pages rapides depuis un modèle, chacune avec URL uniques et liens internes.`)
};

const pt_svc_programmatic_seo_pages_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Milhares de páginas rápidas a partir de um modelo, cada uma com URL únicos e ligações internas.`)
};

const zh_svc_programmatic_seo_pages_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一套模板生成几千个快页面，每个都有独立 URL 和内链。`)
};

const tr_svc_programmatic_seo_pages_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tek şablondan binlerce hızlı sayfa, her biri benzersiz URL ve iç bağlantılı.`)
};

const ru_svc_programmatic_seo_pages_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тысячи быстрых страниц из одного шаблона, у каждой уникальные URL и внутренние ссылки.`)
};

const pl_svc_programmatic_seo_pages_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Pages_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tysiące szybkich stron z jednego szablonu, każda z unikalnymi URL i linkami wewnętrznymi.`)
};

/**
* | output |
* | --- |
* | "Thousands of fast pages from one template, each with unique URLs and internal links." |
*
* @param {Svc_Programmatic_Seo_Pages_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_pages_desc5 = /** @type {((inputs?: Svc_Programmatic_Seo_Pages_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Pages_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_pages_desc5(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_pages_desc5(inputs)
	if (locale === "de") return de_svc_programmatic_seo_pages_desc5(inputs)
	if (locale === "es") return es_svc_programmatic_seo_pages_desc5(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_pages_desc5(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_pages_desc5(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_pages_desc5(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_pages_desc5(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_pages_desc5(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_pages_desc5(inputs)
	return en_svc_programmatic_seo_pages_desc5(inputs)
});
export { svc_programmatic_seo_pages_desc5 as "svc_programmatic-seo_PAGES_desc" }